enum SlideEvent {
    // コンテンツアップロードでURL生成
    CreateTempFileStarted = "[SlideEvent] CreateTempFileStarted",
    CreateTempFileComplete = "[SlideEvent] CreateTempFileComplete",

    // tempファイルのページ総数の取得
    GetTempPageCountStarted = "[SlideEvent] GetTempPageCountStarted",
    GetTempPageCountComplete = "[SlideEvent] GetTempPageCountComplete",

    // tempファイル表示URLの取得
    GetTempPreviewUrlStarted = "[SlideEvent] GetTempPreviewUrlStarted",
    GetTempPreviewUrlComplete = "[SlideEvent] GetTempPreviewUrlComplete",

    // 新規コンテンツ作成
    CreateNewSlideStarted = "[SlideEvent] CreateNewSlideStarted",
    CreateNewSlideComplete = "[SlideEvent] CreateNewSlideComplete",

    // 新規コンテンツ作成キャンセルでtempファイルの削除
    DeleteTempFileStarted = "[SlideEvent] DeleteTempFileStarted",
    DeleteTempFileComplete = "[SlideEvent] DeleteTempFileComplete",

    // コンテンツ情報取得
    GetSlideByIdStarted = "[SlideEvent] GetSlideByIdStarted",
    GetSlideByIdComplete = "[SlideEvent] GetSlideByIdComplete",

    // コンテンツページ総数の取得
    GetSlidePageCountStarted = "[SlideEvent] GetSlidePageCountStarted",
    GetSlidePageCountComplete = "[SlideEvent] GetSlidePageCountComplete",

    // コンテンツ表示URLの取得
    GetSlidePreviewImageUrlStarted = "[SlideEvent] GetSlidePreviewImageUrlStarted",
    GetSlidePreviewImageUrlComplete = "[SlideEvent] GetSlidePreviewImageUrlComplete",

    // コンテンツ編集
    EditSlideStarted = "[SlideEvent] EditSlideStarted",
    EditSlideComplete = "[SlideEvent] EditSlideComplete",
    EditSlideFailed = "[SlideEvent] EditSlideFailed",

    // コンテンツ情報のリセット処理
    ResetSlideInfo = "[SlideEvent] ResetSlideInfo",

    // コンテンツの削除
    DeleteSlideStarted = "[SlideEvent] DeleteSlideStarted",
    DeleteSlideComplete = "[SlideEvent] DeleteSlideComplete",
    DeleteSlideFailed = "[SlideEvent] DeleteSlideFailed",

    // コメントの追加
    AddSlideCommentStarted = "[SlideEvent] AddSlideCommentStarted",
    AddSlideCommentComplete = "[SlideEvent] AddSlideCommentComplete",
    // コメントの編集
    UpdateSlideCommentStarted = "[SlideEvent] UpdateSlideCommentStarted",
    UpdateSlideCommentComplete = "[SlideEvent] UpdateSlideCommentComplete",
    // コメントの削除
    DeleteSlideCommentStarted = "[SlideEvent] DeleteSlideCommentStarted",
    DeleteSlideCommentComplete = "[SlideEvent] DeleteSlideCommentComplete",
    // コメントの返信
    ReplayToSlideCommentStarted = "[SlideEvent] ReplayToSlideCommentStarted",
    ReplayToSlideCommentComplete = "[SlideEvent] ReplayToSlideCommentComplete",
}

export default SlideEvent;
